import { Alert, Modal, Select, Space, Spin, Table, message } from "antd";
import { useEffect, useState } from "react";
import { getDetail, updateDownloadPolicy } from "@/apis/discover";

const policyOptions = [
  { value: "ANONYMOUS", label: "无需登录" },
  { value: "LOGIN_REQUIRED", label: "需要登录" },
];

export default function DownloadPolicyModal({ resource, onClose }) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    setDetail(null);
    setError(false);
    if (!resource?.resourceUuid) return;
    setLoading(true);
    getDetail({ resourceUuid: resource.resourceUuid })
      .then(result => { if (active) { setDetail(result.data); setError(!result.data); } })
      .catch(() => { if (active) setError(true); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [resource?.resourceUuid]);

  const save = async (mode, fileUuid) => {
    setSaving(true);
    try {
      const downloadAuthMode = mode === "INHERIT" ? null : mode;
      await updateDownloadPolicy({ resourceUuid: resource.resourceUuid, ...(fileUuid ? { fileUuid } : {}), downloadAuthMode });
      setDetail(previous => fileUuid
        ? { ...previous, files: previous.files.map(file => file.fileUuid === fileUuid ? { ...file, downloadAuthMode } : file) }
        : { ...previous, downloadAuthMode });
      message.success("下载权限已更新");
    } catch (error) {
      // Shared request handling displays the server error. Keep the previous policy on failure.
    } finally {
      setSaving(false);
    }
  };

  return <Modal title={`下载权限 · ${resource?.title || ""}`} open={!!resource} onCancel={onClose} footer={null} width={760}>
    <Spin spinning={loading || saving}>
      {error && <Alert type="error" message="加载下载权限失败，请关闭后重试" />}
      {detail && <>
        <Alert type="info" showIcon message="公开、审核通过且允许下载的资源默认无需登录；私有资源仍按原有访问权限限制。修改后立即生效。" />
        <Space style={{ margin: "20px 0" }}>
          <span>资源默认下载权限：</span>
          <Select aria-label="资源默认下载权限" style={{ width: 180 }} disabled={saving}
            value={detail.downloadAuthMode || "ANONYMOUS"} options={policyOptions} onChange={mode => save(mode)} />
        </Space>
        <Table rowKey="fileUuid" size="small" dataSource={detail.files || []} pagination={{ pageSize: 10 }} columns={[
          { title: "文件", key: "fileName", render: (_, file) => file.fileRelativePath || file.fileName },
          { title: "下载权限", key: "downloadAuthMode", width: 200, render: (_, file) =>
            <Select aria-label={`文件下载权限 ${file.fileName}`} style={{ width: 180 }} disabled={saving}
              value={file.downloadAuthMode || "INHERIT"}
              options={[{ value: "INHERIT", label: "继承资源设置" }, ...policyOptions]}
              onChange={mode => save(mode, file.fileUuid)} /> },
        ]} />
      </>}
    </Spin>
  </Modal>;
}
